(() => {
  angular.module('app.components')
    .directive('relativeTime', ['$timeout', '$filter', function ($timeout, $filter) {
      var relativeDateFilter = $filter('relativeDate');

      function getUpdateInterval(timestamp) {
        var elapsedSeconds = Math.round((new Date() - new Date(timestamp)) / 1000),
            intervalLength = 1000 * 60 * 15; // default update frequency is 15 minutes

        if (elapsedSeconds <= 60) { // for the first minute, update every second
          intervalLength = 1000;
        } else if (elapsedSeconds <= 60 * 10) { // for the first 10 minutes, update every 15 seconds
          intervalLength = 1000 * 15;
        } else if (elapsedSeconds <= 60 * 60) { // for the first hour, update every 5 minutes
          intervalLength = 1000 * 60 * 5;
        }

        return intervalLength;
      }

      function update(scope, element) {
        var timestampMillis = scope.relativeTime * 1000;
        element.text(relativeDateFilter(timestampMillis));
        $timeout(function () {
          update(scope, element);
        }, getUpdateInterval(timestampMillis));
      }

      return {
        scope: {
          relativeTime: '@'
        },
        link: function (scope, element, attrs) {
          attrs.$observe('relativeTime', function (relativeTime) {
            update(scope, element);
          });
        }
      };

    }]);

})();
